import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {adminUiTexts} from 'data/ui-texts';
import apiHelper from 'helpers/api-helper';
import {getSchoolStats} from 'helpers/stats-helper';
import Button from 'components/ui/button/button';
import './popup-reset-school.scss';

const PopupResetSchool = ({schoolData, games, closePopup}) => {
	
	/* Loading status */
	const [isLoading, setIsLoading] = useState(false);

	/* Error message */
	const [errorMessage, setErrorMessage] = useState(null);


	/* Popup text */
	const popupText = 
		JSON.parse(JSON.stringify(adminUiTexts.resetSchoolPopup.text)).replace('%school%', schoolData.name);

	/* School stats */
	const schoolGames = games.filter((g) => {return g.schoolId === schoolData.id;});
	const {playthroughCount, studentCount} = getSchoolStats(schoolData, schoolGames);

	/**
	 * Reset school
	 */
	const handleResetSchool = () => {
		if (isLoading) return;
		setErrorMessage(null);
		setIsLoading(true);

		apiHelper('admin/reset-school', {schoolId: schoolData.id}).then(() => {
			closePopup();
		}).catch((error) => {
			console.error(error);
			setIsLoading(false);
			setErrorMessage(JSON.stringify(error));
		});
	};

	return (
		<div className='PopupResetSchool' onClick={() => {closePopup();}}>
			<div className='PopupResetSchool-content' onClick={(e) => {e.stopPropagation();}}>
				<div className='PopupResetSchool-title'>
					<span>{adminUiTexts.resetSchoolPopup.title}</span>
				</div>
				<div className='PopupResetSchool-text'>
					<span>{popupText}</span>
				</div>
				<div className="PopupResetSchool-stats">
					<div className="PopupResetSchool-statsRow">
						<span>{adminUiTexts.schoolList.playthroughs}:</span>
						<span>{playthroughCount}</span>
					</div>
					<div className="PopupResetSchool-statsRow">
						<span>{adminUiTexts.schoolList.students}:</span>
						<span>{studentCount}</span>
					</div>
				</div>
				

				{errorMessage &&
					<div className='PopupResetSchool-errorMessage'>
						<span>{errorMessage}</span>
					</div>
				}
				<div className='PopupResetSchool-buttons'>
					<div className='PopupResetSchool-confirmBtn'>
						<Button
							isLoading={isLoading}
							isDisabled={isLoading}
							text={adminUiTexts.resetSchoolPopup.confirmBtn}
							classes={['blueRounded']}
							onClick={handleResetSchool}
						/>
					</div>
					<div className='PopupResetSchool-cancelBtn'>
						<Button
							isDisabled={isLoading}
							text={adminUiTexts.resetSchoolPopup.cancelBtn}
							classes={['blueRounded']}
							onClick={() => {closePopup();}}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

PopupResetSchool.propTypes = {
	schoolData: PropTypes.object.isRequired,
	games: PropTypes.array.isRequired,
	closePopup: PropTypes.func.isRequired,
};

export default PopupResetSchool;